export const go_target_key_all = 'go_target_fin_statement_account_statement'
export const go_target_key_table = 'go_target_fin_statement_account_statement_table'